export enum SPLIT_VIEW_TYPE {
	FILTER_CONSULTANTS = "FILTER_CONSULTANTS",
	TIME_REPORT_DETAILS = "TIME_REPORT_DETAILS",
}
